export default "__VITE_ASSET__Dhg$sBPW__"